import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { MessageService } from '@shared/services/message-service';
import { Carrier } from 'projects/shared/src/lib/models/carrier';
import { CarrierService } from 'projects/shared/src/lib/services/carrier.service';

@Component({
    selector: 'app-add-carrier-form',
    templateUrl: './add-carrier-form.component.html',
    styleUrls: ['./add-carrier-form.component.scss']
})
export class AddCarrierFormComponent implements OnInit {
    carrier: Carrier;
    @Input() carriers: Carrier[] = [];
    @Input() displayDialogFromForm: boolean;
    @Output() displayDialogFromFormChange = new EventEmitter<boolean>();
    @Output() update: EventEmitter<Carrier> = new EventEmitter<Carrier>();
    carrierForm: UntypedFormGroup;

    working: boolean;

    get carrierName(): AbstractControl { return this.carrierForm.get('carrierName'); }
    get carrierCode(): AbstractControl { return this.carrierForm.get('carrierCode'); }
    get phoneNumber(): AbstractControl { return this.carrierForm.get('phoneNumber'); }

    constructor(private messageService: MessageService, private carrierService: CarrierService) { }

    ngOnInit() {
        this.working = false;

        this.carrierForm = new UntypedFormGroup({
            carrierName: new UntypedFormControl('', Validators.required),
            carrierCode: new UntypedFormControl('', [ Validators.required, Validators.pattern(/^[A-Z0-9]{2,4}$/) ]),
            phoneNumber: new UntypedFormControl('', [ Validators.maxLength(10) ]),
        });
    }

    closeAddCarrierDialog() {
        this.displayDialogFromFormChange.emit(false);
        this.carrierForm.reset();
    }

    saveCarrier() {
        if (!this.carrierForm.valid) {
            this.carrierForm.markAllAsTouched();

            this.messageService.add({ severity: 'warn', summary: 'Could not Create Carrier', detail: 'Fields are required.' });
        } else {
            this.carrier = Object.assign({}, this.carrierForm.value);
            this.carrier.activeFlag = true;
            this.carrier.pendingFlag = true;
            this.working = true;
            this.carrierService.createCarrier(this.carrier).subscribe(carrier => {
                this.carrierCreated(carrier);
                this.messageService.add({
                    severity: 'success', summary: 'Carrier Created',
                    detail: 'Save the load to complete changes.'
                });
                this.closeAddCarrierDialog();
                this.working = false;
            }, _error => {
                this.working = false;
            });
        }
    }

    carrierCreated(carrierCreated: Carrier) {
        this.update.emit(carrierCreated);
    }

    codeExists() {
        const exists = this.carriers.some(cc => cc.carrierCode === this.carrierCode.value);
        if (exists)
            this.carrierCode.setErrors({duplicate: true});
        else
            this.carrierCode.setErrors(null);
    }
}
